module.exports = __webpack_public_path__ + "codicon.ff6b888d.ttf";